import React from "react";
import { Breadcrumbs, Loader } from "..";
import WatermarkBackground from "../common/WatermarkBackground";

const Layout = ({ children, data }) => {
  if (data && data !== undefined) {
    return (
      <WatermarkBackground>
        {children}
      </WatermarkBackground>
    );
  }
  return <Loader />;
};

export default Layout;
